import React from "react";

const Gradients = () => {
  return (
    <div className="gradients">
      <div className="gradient behind" color="blue"></div>
      <div className="gradient" color="red"></div>
      <div className="gradient" color="green"></div>
      <div className="gradient" color="orange"></div>
      <div className="gradient" color="black"></div>
    </div>
  );
};

export default Gradients;
